
import FormElementWrapper from "./FormElementWrapper"
import "./textinput.css"

export default function TextInput({
    name, 
    label,
    initial   = "",
    className = "", 
    isenabled = true, 
    example   = null, 
    onchange  = () => null,
    onblur    = () => null,
    pattern   = null,
    required  = false,
    type      = "text"
}) {


    return <FormElementWrapper className={className}>
        <label htmlFor={name}>{label}</label>
        <input name={name} value={initial} type={type} disabled={!isenabled} placeholder={example} onChange={onchange} onBlur={onblur} pattern={pattern} required = {required}/>
    </FormElementWrapper>

}